export function useLocalStorageKeys(schemaName, sessionId) {
  const ubicacionKey = `agorax_ubicacion_${schemaName}`;
  const carritoKey = sessionId ? `agorax_cart_${sessionId}` : `agorax_cart_${schemaName}`;
  const pedidoKey = `agorax_pedido_activo_${schemaName}`;
  const vistaKey = `agorax_vista_catalogo_${schemaName}`;

  return { ubicacionKey, carritoKey, pedidoKey, vistaKey };
}
